// extracted by mini-css-extract-plugin
export var marginNegative = "_6q-5 _6q-3 _6q-1";
export var marginPositive = "_6q-4 _6q-3 _6q-1";
export var modalContent = "_6q-6";
export var samplesTable = "_6q-8";
export var samplesTableContainer = "_6q-7";
export var statBox = "_6q-a";
export var tableCell = "_6q-1";
export var tableCellCenter = "_6q-2 _6q-1";
export var tableCellRight = "_6q-3 _6q-1";
export var tableHeader = "_6q-0";
export var trackingNumber = "_6q-9";